import React from 'react';
import { Box, Typography } from "@mui/material";

const _ep_TEXT_SIMPLE_TITLE = ({ texts }) => {
    const item = texts?.[0];
    if (!item?.Title) return null;

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.25,
                mx: { xs: 2, sm: 2.5 },
                mt: 3.5,
                mb: 1.5
            }}
        >
            {/* نوار گرادیانی شاخص برند جیم‌پین */}
            <Box
                sx={{
                    width: 4,
                    height: 20,
                    borderRadius: "4px",
                    background: "linear-gradient(180deg, #e7333e 0%, #b22831 100%)",
                    boxShadow: "0 2px 8px rgba(231, 51, 62, 0.4)",
                    flexShrink: 0
                }}
            />

            <Typography
                variant="h6"
                component="h2"
                sx={{
                    fontWeight: 800,
                    fontSize: { xs: "1.05rem", sm: "1.15rem" },
                    color: "text.primary",
                    letterSpacing: "-0.2px",
                    lineHeight: 1.3
                }}
            >
                {item.Title}
            </Typography>
        </Box>
    );
};

export default React.memo(_ep_TEXT_SIMPLE_TITLE);

